export const LOCAL_STORAGE_CMS_PREVIEW_KEY = 'cmsPreview';
